import angular from 'angular';

// we do not have jQuery - maybe we will some day
if (!/^jQuery/i.test(angular.element.expando)) {
  const jqLite = angular.element;

  // monkey patch jqLite's clone method
  const _clone = jqLite.prototype.clone;
  jqLite.prototype.clone = function clone(...args) {
    // call original method in the same 'this' context
    // with the same arguments and hold on to the result
    const result = _clone.apply(this, args);

    const [copyEventsAndData] = args;

    // jQuery supports cloning elements also with their event handlers and data
    // this code reataches those handlers to the cloned elements
    if (copyEventsAndData) {
      Array.prototype.slice.call(this).forEach((element, i) => {
        // this is angular's supposedly "undocumented "private" function !!!"
        // but jQuery does it in the same way so we will too
        const { events, data } = jqLite._data(element);

        Object.keys(events).forEach((eventName) => {
          const handlers = events[eventName];
          handlers.forEach((handler) => {
            result.eq(i).on(eventName, handler);
          });
        });

        Object.keys(data).forEach((dataKey) => {
          result.eq(i).data(dataKey, data[dataKey]);
        });
      });
    }

    return result;
  };
}
